import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from './index'

type ThemeSlice = {
  mode: 'dark' | 'light' | 'unset'
}

const initialState: ThemeSlice = {
  mode: <'dark' | 'light'>localStorage.getItem('mode') ?? 'unset',
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggle(state, action: PayloadAction<'dark' | 'light'>) {
      state.mode = action.payload
      localStorage.setItem('mode', state.mode)
    },
  },
})

export const { toggle } = themeSlice.actions

export const themeSelector = (state: RootState) => state.theme

export default themeSlice.reducer
